module.exports = __webpack_public_path__ + "img/popup-product-onboarding.b33de555.svg";